import React from 'react';
import { Tariffs } from './tariffsData';
import { Table } from 'antd';
import quotaColumns from './columns/quotaColumns';
import { singleRoomColumns } from './columns/singleRoomColumns';
import { IColumn } from 'interfaces';
import { renderCell } from './helpers/renderCell';
import classes from './TariffsComponent.module.scss';
import { TariffData } from './tariffsData';

export type TariffsTableProps = {
  t: any;
  userData: any;
  isLoadingUserData: boolean;
  endedTariffLifetime: string | null;
  forAYear: boolean;
  handleOpenModal: (tariffName: Tariffs) => void;
  updateDataSource: (newDataSource: any) => void;
  dataSource: any;
  mode: 'single' | 'quota';
  tariffsApiData: TariffData[];
  isTariffsLoading: boolean;
  roomConstraints: {
    members_amount: number;
    total_document_size: number;
  } | null;
};

const rowOn4Columns = [
  'compare_title',
  'safety_subTitle',
  'documents_subTitle',
  'confident_subTitle',
  'integrations_subTitle',
  'additional_subTitle',
];

const sharedOnCell = (info: { key: string }) => {
  if (rowOn4Columns.includes(info.key)) {
    return { colSpan: 0 };
  }
  return {};
};

const TariffsTable: React.FC<TariffsTableProps> = ({
  t,
  userData,
  isLoadingUserData,
  endedTariffLifetime,
  forAYear,
  handleOpenModal,
  updateDataSource,
  dataSource,
  mode,
  tariffsApiData,
  isTariffsLoading,
  roomConstraints,
}) => {
  const columns = mode === 'quota' ? quotaColumns : singleRoomColumns;
  
  const customColumns = columns.map((col: IColumn) => ({
    ...col,
    render: (value: any, info: any) => {
      return renderCell({
        value,
        info,
        col,
        t,
        userData,
        isLoadingUserData,
        endedTariffLifetime,
        forAYear,
        handleOpenModal,
        updateDataSource,
        dataSource,
        mode,
        tariffsApiData,
        isTariffsLoading,
        roomConstraints,
      });
    },
    onCell: getOnCellLogic(col, mode),
  }));

  return (
    <Table
      columns={customColumns}
      size='large'
      dataSource={dataSource}
      showHeader={false}
      className={classes.tariffsTable}
      pagination={false}
      rowHoverable={false}
      // scroll={{
      //   x: 'max-content'
      // }}
    />
  );
};

const getOnCellLogic = (col: IColumn, mode: 'single' | 'quota') => {
  if (mode === 'quota') {
    return col.key === Tariffs.Basic
      ? (info: { key: string }) => ({
          colSpan: rowOn4Columns.includes(info.key) ? 4 : 1,
        })
      : sharedOnCell;
  } else {
    return col.key !== Tariffs.Trial
      ? sharedOnCell
      : (info: { key: string }) => ({
          colSpan: rowOn4Columns.includes(info.key) ? 4 : 1,
        });
  }
};

export default TariffsTable;
